export default "__VITE_ASSET__3cca66a2__"